export enum AuditEntityTypes {
  Account = "Account",
  Organisation = "Organisation",
}
